import React from 'react';
export function Section5Witnessed() {
  const cases = [{
    id: 'CASO PRESENCIADO #1',
    location: 'Miami, Florida',
    situation: 'Mujer, 38 años. Separada de su esposo por 4 meses. Sin contacto desde la ruptura. Había sido víctima previamente de dos estafas espirituales.',
    presence: 'Confirmada — durante evaluación inicial y seguimiento completo.',
    result: 'A las 9 horas del proceso, el esposo estableció contacto espontáneo. A las 18 horas, solicitó una reunión personal. El equipo investigador verificó el contacto de forma directa.',
    statement: '"No encontramos ninguna variable externa que explicara el cambio de comportamiento del esposo. No hubo intermediarios. No hubo presión de ningún tipo. El contacto fue completamente espontáneo."'
  }, {
    id: 'CASO PRESENCIADO #2',
    location: 'Hialeah, Florida',
    situation: 'Hombre, 33 años. Su pareja había iniciado una nueva relación. Llevaba 3 meses sin comunicación con ella.',
    presence: 'Confirmada — presente durante el proceso completo.',
    result: 'A las 12 horas, la pareja terminó la nueva relación. A las 15 horas, ella misma buscó contacto con el sujeto del caso.',
    statement: '"Presenciamos el momento exacto en que recibió el mensaje. Fue completamente inesperado para él. No había habido ningún tipo de comunicación previa que lo provocara."'
  }, {
    id: 'CASO PRESENCIADO #3',
    location: 'Houston, Texas',
    situation: 'Mujer, 45 años. Dos años de separación total. Caso catalogado internamente como de alta complejidad.',
    presence: 'Confirmada — seguimiento de 30 días completos.',
    result: 'Proceso de 21 horas. Resultado: Reunificación completa y restauración del vínculo afectivo.',
    statement: '"Documentamos el proceso paso a paso. La transformación en la dinámica relacional fue evidente y sostenida en el tiempo, desafiando todas las expectativas iniciales de nuestro equipo."'
  }];
  return <section className="w-full bg-white py-16 px-4 border-b border-gray-200" data-id="element-144">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-145">
        <div className="space-y-4 text-center" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900" data-id="element-147">
            LO QUE NUESTROS INVESTIGADORES PRESENCIARON EN PERSONA
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto mt-6" data-id="element-148"></div>
        </div>

        <p className="text-lg text-gray-800 font-serif leading-relaxed max-w-3xl mx-auto text-center bg-gray-50 p-6 border border-gray-200 shadow-sm" data-id="element-149">
          Con autorización del Templo y de las personas involucradas, nuestro
          equipo estuvo presente como testigos directos en varios procesos
          realizados por el Maestro Mayor. Lo que documentamos a continuación no
          es un testimonio de terceros. Es lo que vimos con nuestros propios
          ojos.
        </p>

        <div className="space-y-8" data-id="element-150">
          {cases.map((caseFile, index) => <div key={index} className="bg-white border border-gray-300 border-l-8 border-l-gold-500 shadow-sm p-6 md:p-8 space-y-6" data-id="element-151">
              <div className="border-b border-gray-200 pb-4" data-id="element-152">
                <h3 className="text-xl font-bold text-navy-900 font-mono tracking-tight" data-id="element-153">
                  {caseFile.id} — {caseFile.location}
                </h3>
              </div>

              <div className="space-y-4 text-base md:text-lg font-serif" data-id="element-154">
                <p data-id="element-155">
                  <strong className="font-sans text-navy-900 uppercase text-xs tracking-wider block mb-1" data-id="element-156">
                    Situación documentada:
                  </strong>
                  <span className="text-gray-800" data-id="element-157">{caseFile.situation}</span>
                </p>
                <p data-id="element-158">
                  <strong className="font-sans text-navy-900 uppercase text-xs tracking-wider block mb-1" data-id="element-159">
                    Presencia del equipo investigador:
                  </strong>
                  <span className="text-gray-800" data-id="element-160">{caseFile.presence}</span>
                </p>
                <p data-id="element-161">
                  <strong className="font-sans text-navy-900 uppercase text-xs tracking-wider block mb-1" data-id="element-162">
                    Resultado observado:
                  </strong>
                  <span className="text-gray-800 font-bold" data-id="element-163">
                    {caseFile.result}
                  </span>
                </p>
              </div>

              <div className="bg-gray-50 p-6 border-l-4 border-navy-900 italic text-gray-700 font-serif mt-6 shadow-sm" data-id="element-164">
                <strong className="font-sans text-navy-900 uppercase text-xs tracking-wider block mb-2 not-italic" data-id="element-165">
                  Declaración del investigador presente:
                </strong>
                <p className="text-lg leading-relaxed" data-id="element-166">{caseFile.statement}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}